<template>
  <ModalDialog
    pop-name="理論と実際タグ入力補助"
    dialog-width="50%"
    dialog-height="35%"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div>
        <div>
          <div ref="wrapper" class="fd__wrapper">
            <div class="fd__list">
              <div id="recordWindows" class="">
                <input
                  v-if="filterCheck"
                  id="filterTextBox"
                  v-model="filterString"
                  class="form-control a"
                  type="text"
                  placeholder="Filter..."
                  @input="change($event)"
                  @focus="oninputfocus"
                />
                <div v-else class="d-flex col-12">
                  <div class="col-11">
                    <span
                      v-for="(item1, index1) in valueadd"
                      :key="index1"
                      class="badge b-form-tag d-inline-flex align-items-baseline mw-100 mr-1 badge-secondary"
                    >
                      <span
                        class="b-form-tag-content flex-grow-1 text-truncate"
                        >{{ item1.name }}</span
                      >
                      <button
                        aria-keyshortcuts="Delete"
                        type="button"
                        aria-label="Remove tag"
                        class="close b-form-tag-remove"
                        @click="onremoveCurt(index1)"
                      >
                        ×
                      </button>
                    </span>
                  </div>
                  <button
                    aria-keyshortcuts="Delete"
                    type="button"
                    aria-label="Remove tag"
                    class="closeall b-form-tag-remove col-1"
                    @click="onremoveCurtAll()"
                  >
                    ×
                  </button>
                </div>
              </div>
              <!-- -->
              <ul v-if="listShow">
                <li class="fd__item">
                  <TreeView
                    id="spBalance"
                    :tree-data="filteredItems"
                    @checkedchange="checkedchange"
                  ></TreeView>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer> </template>
  </ModalDialog>
</template>

<script>
export default {
  name: 'InputAuxiliaryPartscopy',
  props: {
    treeData: Object
  },
  data() {
    return {
      listShow: false,
      filterCheck: true,
      filteredItems: { title: '', children: [] },
      filterString: null,
      filterString1: '',
      showList: false,
      selectedValue: '',
      showEmptyItem: 'true',
      disabled: 'false',
      ignoreCase: 'true',

      placeholder: 'Please select...',
      title: 'fruit',
      idKey: 'id',
      valueKey: 'name',
      textKey: 'name',
      filterTargetKey: 'title',

      valueadd: []
    }
  },
  computed: {},
  created() {
    $(function () {
      $('.treenodecss>span').off('click')
      $('.treenodecss>span').click(function () {
        $(this).parent().next('ul').slideToggle()
        $(this)
          .children('.img')
          .toggleClass('push')
          .parents('li')
          .siblings()
          .find('.img')
          .removeClass('push')
      })
    })
  },
  mounted: function () {

    this.listShow = false
    this.filteredItems.title = this.treeData.title
    this.treeData.children.forEach(item => {
      this.filteredItems.children.push(item)
    })

    $(function () {
      $('#recordWindows').show()
    })
  },
  methods: {
    change(e) {
      this.filterString = e.target.value
      this.filteredItems = { title: '', children: [] }
      this.filteredItems.title = this.treeData.title
      this.filteredItems.children = this.filterTree(
        this.treeData.children,
        this.filterString
      )
    },
    filterTree(array, title) {
      const getNodes = (result, object) => {
        if (
          title === null ||
          title === '' ||
          object.title.indexOf(title) >= 0
        ) {
          result.push(object)
          return result
        }
        if (Array.isArray(object.children)) {
          const children = object.children.reduce(getNodes, [])
          if (children.length) result.push({ ...object, children })
        }
        return result
      }

      return array.reduce(getNodes, [])
    },

    oninputfocus() {
      this.listShow = true

      this.filterCheck = true
    },
    checkedchange(title, ischecked) {
      if (ischecked) {
        this.valueadd.push({
          name: title,
          isTrue: true
        })
      } else {
        this.valueadd = this.valueadd.filter(ii => ii.name !== title)
      }

      if (this.valueadd.length === 0) {
        this.filterCheck = true
      } else {
        this.filterCheck = false
      }
    },
    onremoveCurt(index1) {
      this.valueadd[index1].isTrue = false
      this.valueadd.splice(index1, 1)
    },
    onremoveCurtAll() {
      this.valueadd = []
      this.filterCheck = true
      this.filteredItems.children.forEach(item => {
        item.children.forEach(i => {
          i.children.forEach(ii => {
            ii.ischecked = false
          })
        })
      })
    },

    closeModal() {
      this.$emit('close', this.valueadd)
    }
  }
}
</script>

<style scoped lang="scss">
:hover.link {
  color: RGBA(50, 102, 222, 0.7);
}
#recordWindows {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}
:hover.link {
  color: RGBA(50, 102, 222, 0.7);
}
#filterTextBox {
  border: none;
}

.fd__wrapper {
  position: relative;
  width: 100%;
  .badge {
    color: rgb(83, 83, 83);
    font-size: 16px;
    .text-truncate {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .close {
      border: 0;
    }
  }
  .closeall {
    border: 0;
  }
  * {
    font-size: 1rem;
  }
  input.fd__display-textbox,
  input.fd__filter-textbox {
    width: 100%;
  }
  .fd__list {
    z-index: 1 !important;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 4px;
    border: solid 1px rgb(192, 192, 192);
    background: white;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
    margin-top: -1px;
    ul {
      margin: 4px 0 0 0;
      padding: 4px;
      overflow-x: auto;
      overflow-y: scroll;
      max-height: 40vh;
      li {
        padding: 4px 1px;
        cursor: pointer;
        list-style: none;
        line-height: 1;
        &.fd__item:hover {
          background: aliceblue;
        }
      }
    }
  }
}
</style>
